import { NavLink, Stack } from '@mantine/core';
import {
  IconApps,
  IconUsers,
  IconCreditCard,
  IconWorld,
} from '@tabler/icons-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useCompany } from '../../hooks/useCompany';
import { RoleGuard } from '../common/RoleGuard';

const navItems = [
  {
    label: 'Сервисы',
    icon: IconApps,
    path: '/services',
    roles: ['manager', 'superadmin'],
  },
  {
    label: 'Сотрудники',
    icon: IconUsers,
    path: '/employees',
    roles: ['manager', 'superadmin'],
  },
  {
    label: 'Биллинг',
    icon: IconCreditCard,
    path: '/billing',
    roles: ['manager', 'superadmin'],
  },
  {
    label: 'Домены',
    icon: IconWorld,
    path: '/domains',
    roles: ['manager', 'superadmin'], // manager has read-only
  },
];

export function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { companies, currentCompany } = useCompany();

  return (
    <Stack gap="xs">
      {navItems.map((item) => (
        <RoleGuard
          key={item.path}
          allowedRoles={item.roles}
          isSuperadmin={user?.isSuperadmin}
          companies={companies}
          currentCompanyId={currentCompany?.id}
        >
          <NavLink
            label={item.label}
            leftSection={<item.icon size={20} />}
            active={location.pathname.startsWith(item.path)}
            onClick={() => navigate(item.path)}
          />
        </RoleGuard>
      ))}
    </Stack>
  );
}
